import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatContractDate, NO_CONTRACT_DATE } from '../../../../lib/contractDate';
import { PRICING_TYPE_OPTIONS } from '../../_shared/constants/pricingTypes';
export function HomeSection({ title, icon, action, children }) {
    return /*#__PURE__*/ _jsxs("section", {
        className: "rounded-xl border border-border bg-card p-4 shadow-sm",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "mb-3 flex items-center justify-between gap-2",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center gap-2 text-sm font-semibold text-foreground",
                        children: [
                            icon,
                            /*#__PURE__*/ _jsx("span", {
                                children: title
                            })
                        ]
                    }),
                    action
                ]
            }),
            children
        ]
    });
}
export function SummaryChip({ icon, label, value }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "inline-flex max-w-full items-center gap-1.5 rounded-full border border-border bg-card px-3 py-1 text-xs",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "text-muted-foreground",
                children: icon
            }),
            /*#__PURE__*/ _jsxs("span", {
                className: "text-muted-foreground",
                children: [
                    label,
                    ":"
                ]
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "truncate font-medium text-foreground",
                children: value
            })
        ]
    });
}
export function HomeEmptyState({ icon, title, body }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-start gap-3 rounded-lg border border-dashed border-border bg-muted/40 px-4 py-4",
        children: [
            icon ? /*#__PURE__*/ _jsx("div", {
                className: "mt-0.5",
                children: icon
            }) : null,
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    title ? /*#__PURE__*/ _jsx("div", {
                        className: "text-sm font-medium text-foreground",
                        children: title
                    }) : null,
                    /*#__PURE__*/ _jsx("div", {
                        className: title ? 'mt-0.5 text-xs text-muted-foreground' : 'text-xs text-muted-foreground',
                        children: body
                    })
                ]
            })
        ]
    });
}
export function pricingLabel(code) {
    if (!code) return '—';
    return PRICING_TYPE_OPTIONS.find((o)=>o.value === code)?.label ?? code;
}
/**
 * Program award / effective dates are DATE-ONLY values anchored at UTC
 * midnight on the wire (see `lib/contractDate.ts`). Reading them in the
 * viewer's zone shifts a stored 2026-02-15 to "Feb 14, 2026" anywhere west
 * of Greenwich, so they are read back in the zone that anchored them.
 */ export function formatProgramDate(ts) {
    const label = formatContractDate(ts);
    return label === NO_CONTRACT_DATE ? undefined : label;
}
export function formatCurrency(amount) {
    if (amount == null || amount === 0) return undefined;
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
    }).format(amount);
}
